import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.VarianceReport.Title',
    defaultMessage: 'Variance Report',
  },
  month: {
    id: 'App.VarianceReport.Month',
    defaultMessage: 'Month',
  },
  subtitle: {
    id: 'App.VarianceReport.Subtitle',
    defaultMessage: '{propertyName} · Accrual · Budget: {budgetId}',
  },
  selectPropertyPrompt: {
    id: 'App.VarianceReport.SelectPropertyPrompt',
    defaultMessage: 'Select a property to see its variance report.',
  },
  loadError: {
    id: 'App.VarianceReport.LoadError',
    defaultMessage: 'The variance report could not be loaded.',
  },
  empty: {
    id: 'App.VarianceReport.Empty',
    defaultMessage: 'Intacct has no actuals or budget for this month.',
  },
  account: {
    id: 'App.VarianceReport.Account',
    defaultMessage: 'Account',
  },
  monthActual: {
    id: 'App.VarianceReport.MonthActual',
    defaultMessage: 'Month Actual',
  },
  monthBudget: {
    id: 'App.VarianceReport.MonthBudget',
    defaultMessage: 'Month Budget',
  },
  monthVariance: {
    id: 'App.VarianceReport.MonthVariance',
    defaultMessage: 'Month Variance',
  },
  monthVariancePercent: {
    id: 'App.VarianceReport.MonthVariancePercent',
    defaultMessage: 'Month Var %',
  },
  ytdActual: {
    id: 'App.VarianceReport.YtdActual',
    defaultMessage: 'YTD Actual',
  },
  ytdBudget: {
    id: 'App.VarianceReport.YtdBudget',
    defaultMessage: 'YTD Budget',
  },
  ytdVariance: {
    id: 'App.VarianceReport.YtdVariance',
    defaultMessage: 'YTD Variance',
  },
  ytdVariancePercent: {
    id: 'App.VarianceReport.YtdVariancePercent',
    defaultMessage: 'YTD Var %',
  },
  notes: {
    id: 'App.VarianceReport.Notes',
    defaultMessage: 'Notes',
  },
  notePlaceholder: {
    id: 'App.VarianceReport.NotePlaceholder',
    defaultMessage: 'Add a note',
  },
  noteEditedBy: {
    id: 'App.VarianceReport.NoteEditedBy',
    defaultMessage: 'Last edited by {name} on {date}',
  },
  noteSaveError: {
    id: 'App.VarianceReport.NoteSaveError',
    defaultMessage: 'The note could not be saved.',
  },
  drillDownHint: {
    id: 'App.VarianceReport.DrillDownHint',
    defaultMessage: 'See the GL entries behind this amount',
  },
  glDetailTitle: {
    id: 'App.VarianceReport.GlDetailTitle',
    defaultMessage: '{label} · {range}',
  },
  rangeMonth: {
    id: 'App.VarianceReport.RangeMonth',
    defaultMessage: 'Month',
  },
  rangeYtd: {
    id: 'App.VarianceReport.RangeYtd',
    defaultMessage: 'Year to date',
  },
  glDetailError: {
    id: 'App.VarianceReport.GlDetailError',
    defaultMessage: 'The GL entries could not be loaded.',
  },
  glDetailEmpty: {
    id: 'App.VarianceReport.GlDetailEmpty',
    defaultMessage: 'No GL entries for this period.',
  },
  glDetailTruncated: {
    id: 'App.VarianceReport.GlDetailTruncated',
    defaultMessage:
      'Showing the first {count} entries. Intacct may have more; see Intacct for the full list.',
  },
  glDate: {
    id: 'App.VarianceReport.GlDate',
    defaultMessage: 'Date',
  },
  glDescription: {
    id: 'App.VarianceReport.GlDescription',
    defaultMessage: 'Description',
  },
  glReference: {
    id: 'App.VarianceReport.GlReference',
    defaultMessage: 'Reference',
  },
  glParty: {
    id: 'App.VarianceReport.GlParty',
    defaultMessage: 'Vendor / Customer',
  },
  glDebit: {
    id: 'App.VarianceReport.GlDebit',
    defaultMessage: 'Debit',
  },
  glCredit: {
    id: 'App.VarianceReport.GlCredit',
    defaultMessage: 'Credit',
  },
  glTotal: {
    id: 'App.VarianceReport.GlTotal',
    defaultMessage: 'Total',
  },
});

export default messages;
